// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kSJ3rxpgvIwoc1j6oRg1 {\n\tmargin-right: 0;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/general/HomeScreen/components/styles/NumberWidget.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;AAChB","sourcesContent":[".badge {\n\tmargin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": "kSJ3rxpgvIwoc1j6oRg1"
};
export default ___CSS_LOADER_EXPORT___;
